<template>
  <b-row>
    <b-col>
      <b-card
        :style="{
          backgroundColor: coloreSfondo,
          color: coloreTesto,
          borderColor: coloreBordo
        }"
        class="card-panel"
        style="margin-bottom:0px;"
      >
        <div slot="header" :style="{ color: coloreTitolo, backgroundColor: coloreBarraTitolo }">
          <!-- Secondary Side --><b>{{ uniTranslation("" + titleCode) }} </b>
        </div>
        <b-row class="unidata-editor">
          <b-col cols="12" sm="12" xl="4" lg="4">
            <label>{{ uniTranslation("TRNSL152") }}</label>
          </b-col>
          <b-col cols="12" sm="12" xl="8" lg="8">
            <b-form-input v-model="Factors.scambio_Turbolento" type="number"></b-form-input>
          </b-col>
        </b-row>
        <div style=" margin-top: 10px"></div>

        <b-row class="unidata-editor">
          <b-col cols="12" sm="12" xl="4" lg="4">
            <label>{{ uniTranslation("TRNSL153") }}</label>
          </b-col>
          <b-col cols="12" sm="12" xl="8" lg="8">
            <b-form-input v-model="Factors.scambio_Laminare" type="number"></b-form-input>
          </b-col>
        </b-row>

        <div style=" margin-top: 10px"></div>

        <b-row class="unidata-editor">
          <b-col cols="12" sm="12" xl="4" lg="4">
            <label>{{ uniTranslation("TRNSL154") }}</label>
          </b-col>
          <b-col cols="12" sm="12" xl="8" lg="8">
            <b-form-input v-model="Factors.attrito_Laminare" type="number"></b-form-input>
          </b-col>
        </b-row>

        <div style=" margin-top: 10px"></div>

        <b-row class="unidata-editor">
          <b-col cols="12" sm="12" xl="4" lg="4">
            <label>{{ uniTranslation("TRNSL155") }}</label>
          </b-col>
          <b-col cols="12" sm="12" xl="8" lg="8">
            <b-form-input v-model="Factors.attrito_Turbolento" type="number"></b-form-input>
          </b-col>
        </b-row>

        <div style=" margin-top: 10px"></div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {},
  props: {
    titleCode: {
      type: String,
      required: true
    },
    guid: {
      type: String,
      required: true
    },
    side: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      coloreSfondo: "",
      coloreTesto: "",
      coloreBordo: "",
      coloreTitolo: "",
      coloreBarraTitolo: "",
      Factors: {}
    };
  },
  computed: {
    ...mapGetters("_prjModule", ["projects"]),
    ...mapGetters("_colorsModule", ["cardColors"]),
    saveFactors: function() {
      var that = this;
      var obj = JSON.parse(JSON.stringify(that.Factors));

      obj.scambio_Turbolento = that.check(that.Factors.scambio_Turbolento);
      obj.scambio_Laminare = that.check(that.Factors.scambio_Laminare);
      obj.attrito_Turbolento = that.check(that.Factors.attrito_Turbolento);
      obj.attrito_Laminare = that.check(that.Factors.attrito_Laminare);

      return obj;
    }
  },
  watch: {
    cardColors() {
      this.setColors();
    }
  },
  mounted: function() {
    var that = this;
    that.setColors();

    that.loadFactors();
  },
  methods: {
    ...mapActions("_factorsModule", ["saveFactorsAction", "getByGeomGUIDAndSideAction"]),
    setColors() {
      var that = this;
      that.coloreSfondo = that.cardColors[0] + " !important"; // 7 elementi. 0=sfondo 1=barra titolo 2=testo 3=colore titolo 4= sfondo tab 5=testo tab 6=testo titolo tab quando selezionata
      that.coloreBarraTitolo = that.cardColors[1];
      that.coloreTesto = that.cardColors[2];
      that.coloreTitolo = that.cardColors[3];
      that.coloreSfondoTab = that.cardColors[4];
      that.coloreTestoTab = that.cardColors[5];
      that.coloreBordo = that.cardColors[6];
    },
    loadFactors() {
      var that = this;
      var payload = {};
      payload.guid = that.guid;
      payload.side = that.side;

      that.getByGeomGUIDAndSideAction(payload).then(data => {
        that.Factors = data;
      });
    },
    check(val) {
      if (val + "" == "") return 1;
      if (val <= 0) return 1;
      return val;
    }
  }
};
</script>

<style lang="scss">
.card .card-header {
  color: transparent;
  background-color: transparent;
  padding: 0px;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

$input-height: 30px;

.unidata-editor {
  background-color: transparent;
  margin: 0 0 0px 0px !important;
  //padding: 10px 0;
  width: 100%;
  outline: none;

  .unidata-item-container {
    border: none;
    height: $input-height !important;
    padding: 0 0px;

    .select {
      border: none;
    }

    .form-control {
      padding: 0px;
      border-radius: 5px;
      height: $input-height !important;

      &.auto-numeric {
        padding: 0 5px;
        text-align: center;
      }

      &.el-select {
        .el-input {
          .el-input__inner {
            height: $input-height !important;
            padding: 0px 25px 0px 5px;
          }
        }
      }
    }

    .form-control:focus {
      box-shadow: none;
    }

    .form-control:disabled {
      background-color: #e8e8e8;
    }
  }
}
</style>
